import React from "react"
import PropTypes from "prop-types"
import { Flex, Typography, Tooltip } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import { EXP_THUMB_COLORS } from "../../constants"
import EmptyState from "components/common/EmptyState"
import { markdownToNode } from "../../utils"
import styles from "../../style.module.css"

const { Text } = Typography

export default function TopExperiencesWidget({ data, description, title }) {
  const { t } = useTranslation()
  // chart_data for list: [{ label, value, rank }]
  const experiences = (Array.isArray(data) ? data : []).map((e, i) => ({
    rank: e.rank ?? i + 1,
    name: e.label ?? "—",
    count: e.value ?? "—",
    bg: EXP_THUMB_COLORS[i % EXP_THUMB_COLORS.length]
  }))

  return (
    <div className={styles.widgetContent}>
      <Flex justify="space-between" align="flex-start" className={styles.widgetHeader}>
        <div>
          <Text strong>{title ?? t("ai_dashboard.widget_top_experiences")}</Text>
          <div><Text type="secondary" className={styles.textSm}>{t("ai_dashboard.by_number_of_bookings")}</Text></div>
        </div>
        {description && (
          <Tooltip title={markdownToNode(description)} placement="topRight" styles={{ body: { maxWidth: 320 } }}>
            <InfoCircleOutlined className={styles.widgetInfoIcon} />
          </Tooltip>
        )}
      </Flex>
      <Flex vertical gap="var(--spacing-ss)" className={styles.rankList}>
        {experiences.length === 0 ? <div className={styles.widgetEmptyState}><EmptyState title={t("ai_dashboard.no_data")} description=" " /></div> : experiences.map((e) => (
          <Flex key={e.rank} align="center" gap={8} className={styles.rankItem}>
            <Text type="secondary" className={styles.rankNum}>{e.rank}</Text>
            <div className={styles.expThumb} style={{ background: e.bg }} />
            <Text className={styles.rankNameEllipsis}>{e.name}</Text>
            <Text strong>{e.count}</Text>
          </Flex>
        ))}
      </Flex>
    </div>
  )
}

TopExperiencesWidget.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  description: PropTypes.string,
  title: PropTypes.string,
}
